import React from 'react';
import { ExternalLink, ShieldCheck, Lock, Scale } from 'lucide-react';

const STRIPE_BENEFITS = [
  { icon: Scale, text: 'You are in control of disputes, chargebacks, and refunds.' },
  { icon: ShieldCheck, text: 'Industry-leading fraud protection on every transaction.' },
  { icon: Lock, text: 'Bank-level security — Rentid never stores your card data.' },
];

const StripeStep = () => (
  <div>
    <div className="preob-stripe">
      <div className="preob-stripe__header">
        <img
          src={`${process.env.PUBLIC_URL}/images/stripe-logo.png`}
          alt="Stripe"
          className="preob-stripe__logo"
        />
      </div>

      <div className="preob-stripe__body">
        <h2 className="preob-stripe__title">Built better for operators and rentals.</h2>
        <p className="preob-stripe__copy">
          With Rentid, you work directly with Stripe. Do more when you're in control of payments for
          your business with a partnership designed for modern rentals.
        </p>

        <ul className="preob-stripe__list">
          {STRIPE_BENEFITS.map((b) => {
            const Icon = b.icon;
            return (
              <li key={b.text} className="preob-stripe__item">
                <span className="preob-stripe__item-icon">
                  <Icon size={14} strokeWidth={2.5} />
                </span>
                <span className="preob-stripe__item-text">{b.text}</span>
              </li>
            );
          })}
        </ul>

        <div className="preob-stripe__cta-wrap">
          <p className="preob-stripe__cta-label">Don't have an account yet?</p>
          <a
            href="https://dashboard.stripe.com/register"
            target="_blank"
            rel="noopener noreferrer"
            className="preob-stripe__cta"
          >
            Create New Stripe Account
            <ExternalLink size={16} />
          </a>
          <p className="preob-stripe__cta-note">
            Opens Stripe in a new tab. Return here once you're done to continue your pre-boarding.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default StripeStep;
